import {Component} from "@angular/core";
import {WebStompService} from "./core/services/webstomp.service";
@Component({
        selector: 'not-found',
        template: ` <h1>Page not found</h1>`
})
export class NotFoundComponent {
        constructor() {
                
        }


}